$(".tabsaccor ul li:first-child a").addClass("active");
$(".item-tab")
  .first()
  .addClass("active");
tabControl();

/*
We also apply the switch when a viewport change is detected on the fly
(e.g. when you resize the browser window or flip your device from 
portrait mode to landscape). We set a timer with a small delay to run 
it only once when the resizing ends. It's not perfect, but it's better
than have it running constantly during the action of resizing.
*/
var resizeTimer;
$(window).on("resize", function (e) {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(function () {
    tabControl();
  }, 250);
});

/*
The function below is responsible for switching the tabs when clicked.
It switches both the tabs and the accordion buttons even if 
only the one or the other can be visible on a screen. We prefer
that in order to have a consistent selection in case the viewport
changes (e.g. when you esize the browser window or flip your 
device from portrait mode to landscape).
*/
function tabControl() {
  var tabs = $(".tabbed-content").find(".tabsaccor");
  if (tabs.is(":visible")) {
    tabs.find("a").on("click", function (event) {
      event.preventDefault();
      var target = $(this).attr("href"),
        tabs = $(this).parents(".tabsaccor"),
        buttons = tabs.find("a"),
        item = tabs.parents(".tabbed-content").find(".item-tab");
      buttons.removeClass("active");
      item.removeClass("active");
      $(this).addClass("active");
      $(target).addClass("active");
    });
  } else {
    var titleListAll = document.querySelectorAll(".tabbed-content .tabsaccor li a");
    var titleList = Array.prototype.slice.call(titleListAll);
    titleList.forEach(title => {
      let getId = title.getAttribute("href").substring(1);
      let curntSection = document.getElementById(getId);
      //   let plusMinus = document.createElement("span");
      let cloneHeading = title.cloneNode(true);
      curntSection.prepend(cloneHeading);
    });

    $(".item-tab").on("click", function (e) {
      e.preventDefault();
      var container = $(this).parents(".tabbed-content"),
        currId = $(this).attr("id"),
        items = container.find(".item-tab");
      container.find(" a").removeClass("active");
      items.removeClass("active");
      $(this).addClass("active");
      container.find(' a[href$="#' + currId + '"]').addClass("active");
    });
  }
}
